import { ChatUserInfo } from "@xapp/stentor-chat-widget";
import { FC, useCallback } from "react";
import { sendChatRating } from "../../store/actions";
import { useChatServerDispatch } from "../../utils/useChatServerDispatch";
import ChatRating from "./ChatRating";

export interface ChatRatingContainerProps {
    readonly agent: ChatUserInfo;
    readonly hasRating: boolean;
    readonly shouldDisplay: boolean;
    readonly time?: string;
}

const ChatRatingContainer: FC<ChatRatingContainerProps> = (props) => {
    const dispatch = useChatServerDispatch();

    const handleRate = useCallback(
        (rating: "bad" | "good" | undefined) => {
            dispatch(sendChatRating(rating));
        },
        [dispatch]
    );

    return (
        <>
            <span className="message-sr-only">{"at " + props.time + " system message"}</span>
            <ChatRating
                agent={props.agent}
                hasRating={props.hasRating}
                shouldDisplay={props.shouldDisplay}
                onRate={handleRate}
            />
        </>
    );
};

export default ChatRatingContainer;
